var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"perform"},[_c('quote-title',{attrs:{"label":"金枝走演"}}),_c('br'),_c('br'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }